import { render, staticRenderFns } from "./PlotItem.vue?vue&type=template&id=3af610a3&scoped=true&"
import script from "./PlotItem.vue?vue&type=script&lang=js&"
export * from "./PlotItem.vue?vue&type=script&lang=js&"
import style0 from "./PlotItem.vue?vue&type=style&index=0&id=3af610a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af610a3",
  null
  
)

export default component.exports